<template>
  <div  class="pc_about_audience">
    <ul v-if="tableData.list.length>0" class="ulList">
      <li class="" v-for="(item,index) in tableData.list" :key="index">
        <div class="left">
          <img :src="item.img" alt="" />
        </div>
        <div class="center">
          <div class="userInformation">
            <p class="h7">
              {{item.name?item.name:item.nickname}}
              <span>{{item.duties}}</span>
            </p>
            <p>Company：{{item.corpname}}</p>
            <p>Contact Information：{{item.mobile}}</p>
          </div>
          <div class="aboutContent">
            <div>
              <p class="title">
                <span>
                  标题：
                </span>
                <!-- {{item.title}}   -->
              </p>
              <!-- <div class="hoverAccording">
                <span class="sanjiao"></span>
                {{item.title}} </div> -->
            </div>
            <p >
              <span>Meeting Time：</span>
              {{item.date}}</p>
            <div class="con">
              <p>
                <span>Content：</span>
                <el-tooltip :content="item.connet" placement="bottom" effect="light">
                  <span>{{item.connet}}</span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <p class="time">{{item.ctime}}</p>
        </div>
        <div class="right">
          <el-button :class="item.status*1==0?'reception ':'reception btn'" :disabled="item.status*1!=0" @click="reception(item.id)">{{item.status*1==0?"Confirm":"undetermined"}}</el-button>
          <el-popconfirm
            v-if="item.status*1==0"
            confirm-button-text="Confirm"
            cancel-button-text="Cancel"
            title="Are you sure to cancel?"
            @onConfirm='isCollect(item.id)'
          >
            <el-button class="del" type="danger" slot="reference">Ignore</el-button>
          </el-popconfirm>
        </div>
      </li>
    </ul>
    <div v-else class="peomp_con">
      <div class="prompt_img">
        <img :src="hrefurl+'/public/icon/without.png'" alt="" />
      </div>
      <p>No data is available! </p>
    </div>
    <!-- <el-pagination
      v-if="tableData.listnum>20"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="tableData.thispage"
      :page-size="20"
      layout="total, prev, pager, next "
      :pager-count="5"
      prev-text="上一页"
      next-text="下一页"
      :total="tableData.listnum * 1"
    >
    </el-pagination> -->
  </div>
</template>

<script>
import { reqMyCorpAppMy, reqCorpAppNeglect, reqCorpAppStatus } from "../../../../api";
export default {
  components:{
  },
   data(){
    return{
      tableData:{
        listnum: "0",
        pagelistnum: 20,
        list:[]
      }
    }
  },
  mounted(){
    this.init()
  },
  methods:{
    handleCurrentChange(a){//当前页改变时
      console.log(a);
      // 调用请求接口
    },

    handleSizeChange(a){//每页条数改变时  备用动态条数
      console.log(a);
    },
    async init(){
      const response = await reqMyCorpAppMy()
      console.log(response);
      if (response.code*1==2) {
        this.tableData={
          list:response.reslist
        }
      }else{
        // this.err(this,'请求失败，稍后重试...')
      }
    },
    async isCollect(id){//忽略
      const response = await reqCorpAppNeglect(id)
      if (response.code==3) {
        let index = this.tableData.list.findIndex(item=>item.id==id)
        if (index>=0) {
          let {tableData} =this
          tableData.list.splice(index,1)
          this.tableData = tableData
        }
        this.success(this,'Ignore Successfully')
      }else{
        this.err(this,'Timeout, please try...')
      }
    },
    async reception(id){
      const response = await reqCorpAppStatus(id)
      console.log(response);
      if (response.code*1==3) {
        this.success(this,"已接待")
        this.init()
      }else{
        this.err(this,"Timeout, please try...")
      }
    }
  }
}
</script>

<style scoped>
  .pc_about_audience{
    width: 100%;
  }
  .ulList{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    padding:10px 4px;
  }
  .ulList>li{
    /* min-width: 330px;
    max-width: 430px; */
    /* width: 48%; */
    width: 100%;
    display: flex;
    /* justify-content: space-between; */
    background-color: #fafafa;
    padding-left: 10px;
    box-sizing: border-box;
    vertical-align: middle;
    margin-bottom: 20px;
    font-size: 12px;
    position: relative;
    border-radius: 5px;
    /* overflow: hidden; */
    min-height: 120px;

  }
  .ulList .left{
    width: 100px;
    vertical-align: middle;
    padding: 10px 0;
  }
  .ulList .center{
    position: relative;
    vertical-align: middle;
    /* min-width: 240px; */
    padding: 10px 10px 10px 20px;
    display: flex;
    width: calc(100% - 200px);
  }
  .userInformation{
    width: 50%;
  }
  .aboutContent{
    width: 50%;
  }
  .aboutContent>div{
    position: relative;
  }
  /* .aboutContent p span{
    color: #008baf;
  } */
  .ulList .center p{
    line-height: 24px;
    font-size: 14px;
  }
  .ulList .center .userInformation p{
    line-height: 30px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ulList .center .userInformation p:first-child{
    font-family: 'FjallaOne-Regular';
  }
  .ulList .center .aboutContent .title{
    position: relative;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    opacity: 0;
  }
  .ulList .center .h7{
    font-size: 18px;
    vertical-align: bottom;
  }
  .center .h7 span{
    vertical-align: bottom;
    font-size: 14px;
    margin-left: 6px;
  }
  .ulList .center .time{
    position: absolute;
    left: 20px;
    bottom: 0px;
    font-size: 12px;
  }
  .ulList .center .aboutContent .con>p{
    max-height: 50px;
    height: auto;
    overflow: hidden;
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ulList .center .aboutContent>div:hover div,
  .ulList .center .aboutContent>div:hover div{
    display: block;
  }
  .ulList .right{
    position: absolute;
    right: 0;
    top: 0;
    width: 100px;
    font-weight: 600;
    vertical-align: middle;
    min-width: 40px;
    text-align: center;
    height: auto;
    font-size: 16px;
    /* padding-top: calc(50% - 7px); */
    height: 120px;
    box-sizing: border-box;
    line-height: 60px;
  }
  .ulList .reception{
    cursor: pointer;
    transition: all .5s;
    border-radius: 5px;
    width: 100px;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
    color: #008baf;
  }
  .ulList .reception:hover{
    border-color: #008baf;
    background-color: #008baf;
    color: white;
  }
  .ulList .btn:hover,
  .ulList .btn{
    color: #333;
    background-color: white;
  }
  .ulList .del{
    color: white;
    background-color: #008baf;
    /* height: 100%;
    width: 100%; */
    border:none;
    /* padding: 0; */
    cursor: pointer;
    transition: all .5s;
    border-radius: 5px;
    width: 100px;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
  }
  .ulList .del:hover{
    background-color:#f08300;
  }

  .prompt_img{
    width: 200px;
    margin: 100px auto 0;
    opacity: .8;
  }
  .peomp_con>p{
    font-size: 17px;
    text-align: center;
    line-height: 24px;
    padding-top: 10px;
    font-family: 'FjallaOne-Regular';
  }
  .goods_jump{
    color: #008baf;
    cursor: pointer;
  }

  .pc_about_audience>>>.el-pagination{
    padding: 40px 0 20px;
    text-align: center;
  }
  .pc_about_audience>>>.el-pager li,
  .pc_about_audience>>>.el-pagination .btn-next, 
  .pc_about_audience>>>.el-pagination .btn-prev{
    background-color: transparent;
  }
  @media (min-width: 768px) and (max-width: 900px) {
    .ulList .center{
      display: block;
    }
    .aboutContent, .userInformation{
      width: 100%;
    }
    .ulList .center .aboutContent .title{
      display: none;
    }
  }

</style>